import React, { useState, useEffect, useMemo } from "react";
// import classes from "../../assets/styles/Pages/Function/CustomURLSListing.module.css";
import ShowFormBuilderFunctions from "../../components/PageComponents/Function/ShowFormBuilderFunctions";
import Loader from "../../components/Loader";
import { useAtom } from "jotai";
import { get, deleteRecord, post, put } from "../../server";
import {
  FORM_BUILDER,
  SEND_EMAIL_TEMPLATE,
  EMAIL_TEMPLATE,
  FUNCTION_STATUS,
} from "../../utils/constants/apiUrl";
import {
  loggedInUser,
  teamIDCheck,
  subscribedPackage,
} from "../../utils/store";
import { toast } from "react-toastify";
import showToast from "../../helpers/showToast";
import ConfirmationModal from "../../components/Modals/ConfirmationModal";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import FormInput from "../../components/Forms/FormInput";
import searchIcon from "../../assets/images/global_icons/searchicon.svg";
import AddIcon from "../../assets/images/global_icons/basil_add-solid.svg";

import _ from "lodash";
import EmptyListingBanner from "../../components/EmptyListingBanner";
import useFunctionsCount from "../../hooks/useFunctionsCount";
import { FaCirclePlus } from "react-icons/fa6";
import FunctionsLimitModal from "../../components/Modals/FunctionsLimitModal";
import functionTypes from "../../utils/constants/functionTypes";
import { trackEvent } from "../../utils/mixpanel";
import { Button, Tab, Tabs } from "react-bootstrap";
import EmailTemplate from "./EmailTemplate";

const FormBuilderListing = () => {
  let emptyCustomUrlData = {
    isNew: true,
    id: "",
    title: "",
    url_path: "",
  };
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const team_id = searchParams.get("team_id");
  const user_id = searchParams.get("user_id");
  const dynamicQRCodeId = searchParams.get("dynamic_qr_code");

  const [loading, setLoading] = useState(true);
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [userTeamId, setUserTeamId] = useAtom(teamIDCheck);
  const [formBuilderListings, setFormBuilderListings] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedData, setSelectedData] = useState(emptyCustomUrlData);
  const [filterText, setFilterText] = useState("");
  const [search, setSearch] = useState("");
  const [textSearch, setTextSearch] = useState("");
  const [leadBuildersSubTab, setLeadBuildersSubTab] = useState("leadBuilders");

  const {
    compareLimits,
    updateCount,
    limitExceededForStarter,
    compareLimitsForDynamicQR,
  } = useFunctionsCount();
  const [showLimitModal, setShowLimitModal] = useState(false);
  const [purchasedPackage, setPurchasedPackage] = useAtom(subscribedPackage);
  const [emailStatus, setEmailStatus] = useState(false);

  const handleFilter = (e) => {
    setFilterText(e.target.value);
  };

  const handleFormBuilder = async () => {
    if (dynamicQRCodeId) {
      const isLimitExceeded = compareLimitsForDynamicQR(
        functionTypes.FORM_BUILDER,
        dynamicQRCodeId
      );
      if (isLimitExceeded) {
        return showToast(
          false,
          "The requested feature is not compatible with your current plan. Upgrade your plan to continue using these features"
        );
      } else {
        navigate(`/function/formBuilder?dynamic_qr_code=${dynamicQRCodeId}`);
      }
    } else if (purchasedPackage.id === 1) {
      limitExceededForStarter()
        .then((isLimitExceeded) => {
          if (isLimitExceeded) {
            setShowLimitModal(true);
          } else {
            navigate("/function/formBuilder");
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } else {
      const isLimitExceeded = compareLimits(functionTypes.FORM_BUILDER);
      if (isLimitExceeded) {
        return showToast(
          false,
          "The requested feature is not compatible with your current plan. Upgrade your plan to continue using these features"
        );
      } else {
        navigate("/function/formBuilder");
      }
    }
  };

  // const handleFormBuilder = async () => {
  //   navigate("/function/formBuilder");
  // };

  const handleCloseModal = () => {
    setFormBuilderListings([]);
    setShowModal(false);
    setShowLimitModal(false);
  };

  // Handle confirmation modal
  const handleShowConfirmationModal = () => setShowConfirmationModal(true);
  const handleCloseConfirmationModal = () => setShowConfirmationModal(false);

  // handle delete
  const handleDelete = (formBuilderId) => {
    setDeleteId(formBuilderId);
    handleShowConfirmationModal(true);
  };

  const handleConfirmDelete = async () => {
    handleCloseConfirmationModal(true);
    setLoading(true);
    let queryParams = "";
    if (dynamicQRCodeId) {
      queryParams += `?dynamic_qr_code_id=${dynamicQRCodeId}`;
    }
    let { status, message } = await deleteRecord(
      `${FORM_BUILDER}/${deleteId}${queryParams}`,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      updateCount(
        functionTypes.FORM_BUILDER,
        functionTypes.DELETE,
        dynamicQRCodeId
      );
      getFormBuilderListing();
      setLoading(false);
      showToast(status, message);
    } else {
      showToast(status, message);
    }
    setLoading(false);
  };

  // Get all custom urls
  const getFormBuilderListing = async () => {
    let queryParams = "";
    if (dynamicQRCodeId) {
      queryParams += `?dynamic_qr_code_id=${dynamicQRCodeId}`;
    }

    if (userTeamId) {
      queryParams += `${queryParams ? "&" : "?"}team_id=${userTeamId}`;
    }
    let { status, message, data } = await get(
      // userTeamId ? FORM_BUILDER + queryParams : FORM_BUILDER,
      `${FORM_BUILDER}${queryParams}`,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    if (status) {
      setFormBuilderListings(data);
    } else {
      showToast(status, message);
    }
    setLoading(false);
  };

  const filteredItems = useMemo(() => {
    const filtered = formBuilderListings.filter((item) =>
      `${item.name || ""}`.toLowerCase().includes(filterText.toLowerCase())
    );

    return filtered;
  }, [filterText, formBuilderListings]);
  const handleGoBack = () => {
    navigate(-1);
  };

  const handleStatus = async (id) => {
    const allFiles = formBuilderListings.find((file) => file.id === id);
    let newStatus = allFiles.status == true ? 0 : 1;
    const previousStatus = allFiles.status ? "Active" : "Inactive";
    const newStatusText = newStatus ? "Active" : "Inactive";

    const source = window.location.search.includes("dynamic_qr_code")
      ? "QR Code"
      : window.location.search.includes("team_id") &&
        window.location.search.includes("user_id")
      ? "Team Function"
      : "Function Page";
    let queryParams = "";
    const team_id = searchParams.get("team_id");
    const user_id = searchParams.get("user_id");
    const dynamic_qr_code = searchParams.get("dynamic_qr_code");

    if (dynamicQRCodeId) {
      queryParams += `?dynamic_qr_code_id=${dynamicQRCodeId}`;
    }
    const payload = {
      id: allFiles.id,
      status: newStatus,
      type: allFiles.function_type,
      team_id: allFiles.team_id,
    };
    let { status, message } = await post(
      `${FUNCTION_STATUS}${queryParams}`,
      payload,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      trackEvent(`Form builder Status Changed from ${source}`, {
        id,
        function_type: allFiles.function_type,
        new_status: newStatusText,
        previous_status: previousStatus,
        team_id,
        user_id,
        dynamic_qr_code,
        source,
      });
      await getFormBuilderListing();
    } else {
      trackEvent(`Form builder Status  failed from ${source}`, {
        id,
        function_type: allFiles.function_type,
        attempted_status: newStatusText,
        previous_status: previousStatus,
        source,
        team_id,
        user_id,
        dynamic_qr_code,
        error_message: message,
      });
      toast.error(message);
    }
    setLoading(false);
  };

  const getHandleStatus = async () => {
    const queryString = `?function_type=form_builder`;
    let { status, message, data } = await get(
      EMAIL_TEMPLATE + queryString,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      setEmailStatus(Boolean(data?.email_to_lead_user));
    } else {
      toast.error(message);
    }
    setLoading(false);
  };

  const handleStatusChange = async () => {
    let newEmailStatus = emailStatus == true ? 0 : 1;
    const payload = {
      email_to_lead_user: newEmailStatus,
    };
    let { status, message } = await put(
      SEND_EMAIL_TEMPLATE,
      payload,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      await getHandleStatus();
    } else {
      toast.error(message);
    }
    setLoading(false);
  };

  useEffect(() => {
    getFormBuilderListing();
    getHandleStatus();
  }, [userTeamId]);

  const handleTracking = (data) => {
    trackEvent(data, {
      message: data,
    });
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="">
          <div className="mainWrapper heading">
            <h1 className="">
              {/* <Link
                onClick={handleGoBack}
                style={{ color: "var(--heading_text_color)" }}
              >
                Functions
              </Link> */}
              <Link to="/" className="function-link">
                Functions
              </Link>
              {` > Lead Builder`}
            </h1>
            <div>
              <div className="d-flex align-items-center justify-content-end mb-2 ">
                {/* <Form.Check
                  type="switch"
                  checked={emailStatus}
                  onChange={handleStatusChange}
                  label="Send Email Template"
                /> */}
                {purchasedPackage.id !== 1 ? (
                  <>
                    {/* <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={emailStatus}
                        onChange={handleStatusChange}
                      />
                      <label class="form-check-label">
                        {emailStatus == true
                          ? "Trun Off Send Email"
                          : "Want To Send Email"}
                      </label>
                    </div> */}
                    {/* <Link to="/function/emailTemplate">
                      <button
                        className="primary_button ms-3"
                        style={{ padding: "10px 15px" }}
                      >
                        Email Template
                      </button>
                    </Link> */}
                    {dynamicQRCodeId !== null ? (
                      <Link
                        className="primary_button ms-3"
                        to={`/qrcode`}
                        style={{ padding: "10px 15px" }}
                      >
                        {`< Back`}
                      </Link>
                    ) : (
                      ""
                    )}
                  </>
                ) : (
                  ""
                )}
              </div>
              {formBuilderListings.length !== 0 ? (
                <div className="d-flex align-items-center justify-content-between mb-3 mobileViewWrapper">
                  <div className="form-check form-switch d-flex align-items-center gap-2 form-group mb-md-0">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="emailStatusSwitch"
                      checked={emailStatus}
                      onChange={handleStatusChange}
                      style={{ marginTop: "-0.5px" }}
                    />
                    <label
                      className="form-check-label mb-0"
                      htmlFor="emailStatusSwitch"
                    >
                      Auto Introductory Email
                    </label>
                  </div>
                  {(loggedUser.role.includes("customer") ||
                    loggedUser.role.includes("team_owner")) && (
                    <Button
                      variant="primary"
                      className="ms-3"
                      onClick={() => {
                        handleFormBuilder();
                        handleTracking("Create Lead Builder button Clicked");
                      }}
                    >
                      <img src={AddIcon} alt="plus" className="me-2" />
                      Create Lead Builder
                    </Button>
                  )}
                </div>
              ) : null}
            </div>
          </div>
          <div className="mainVeiwsWrapper">
            <div className="veiwsWrapper">
              <form
                className="search-form"
                onSubmit={(e) => {
                  e.preventDefault();
                  setSearch(textSearch);
                }}
              >
                <div className="search-wrapper">
                  <img src={searchIcon} alt="search" className="search-icon" />
                  <input
                    type="text"
                    className="search-input"
                    placeholder="Search by title"
                    // value={textSearch}
                    // onChange={(e) => {
                    //   if (e.target.value.length === 0 && search.length !== 0) {
                    //     setSearch("");
                    //   }
                    //   setTextSearch(e.target.value);
                    // }}

                    value={filterText}
                    onChange={handleFilter}
                  />
                </div>
              </form>

              {/* <div className="d-flex gap-2">
                {(activeTab === "card" || activeTab === "lead") && (
                  <button
                    className="btn connections-btn d-flex align-items-center gap-2 ms-3"
                    onClick={handleExportAllCollection}
                  >
                    <img src={ExportIcon} alt="" width="16px" height="16px" />
                    Export Collection
                  </button>
                )}
                <div className="dropdown">
                  <button
                    className="btn connections-btn d-flex align-items-center gap-2"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img src={FilterIcon} alt="Filter" width="16" height="16" />
                    <span>Filter</span>
                  </button>
                  <ul className="dropdown-menu">
                    <li
                      className="dropdown-item"
                      onClick={() => setFilter("newest")}
                    >
                      <span
                        style={{
                          color:
                            filter === "" || filter === "newest"
                              ? "var(--primary_button_color)"
                              : "var(--primary_text_color)",
                        }}
                      >
                        Newest to oldest
                      </span>
                    </li>
                    <li
                      className="dropdown-item"
                      onClick={() => setFilter("oldest")}
                    >
                      <span
                        style={{
                          color:
                            filter === "oldest"
                              ? "var(--primary_button_color)"
                              : "var(--primary_text_color)",
                        }}
                      >
                        Oldest to newest
                      </span>
                    </li>
                    <li className="dropdown-item" onClick={() => setFilter("")}>
                      <span style={{ color: "#E35252" }}>Clear</span>
                    </li>
                  </ul>
                </div>
              </div> */}

              {/* <div className={gridView ? classes.activeGrid : classes.grid}>
                <button onClick={handleGridView}>
                  <BsGrid className={classes.gridIcon} />
                  <span> Grid view</span>
                </button>
              </div> */}
              {/* <div className={!gridView ? classes.activeGrid : classes.grid}>
                <button onClick={handleListView}>
                  <TbLayoutList className={classes.gridIcon} />
                  <span> List view</span>
                </button>
              </div> */}
            </div>
          </div>
          <div className="listWrapper mt-4">
            <Tabs
              activeKey={leadBuildersSubTab}
              onSelect={(k) => setLeadBuildersSubTab(k)}
              className="mb-3"
            >
              <Tab eventKey="leadBuilders" title="Lead Builders">
                {formBuilderListings.length === 0 ? (
                  <EmptyListingBanner
                    headLineText="lead builder"
                    title="Create Lead Builder"
                    onClick={() => {
                      handleFormBuilder();
                      handleTracking("Create Lead Builder button Clicked");
                    }}
                    show={
                      loggedUser.role.includes("customer") ||
                      loggedUser.role.includes("team_owner")
                    }
                  />
                ) : (
                  <ShowFormBuilderFunctions
                    loading={loading}
                    show={showModal}
                    FormBuilders={filteredItems}
                    handleDelete={handleDelete}
                    handleStatus={handleStatus}
                    getFormBuilderListing={getFormBuilderListing}
                    dynamicQRCodeId={dynamicQRCodeId}
                  />
                )}
              </Tab>

              {emailStatus && (
                <Tab
                  eventKey="emailTemplate"
                  title="Lead Builder Email Template"
                >
                  <EmailTemplate />
                </Tab>
              )}
            </Tabs>
          </div>
        </div>
      )}
      <ConfirmationModal
        show={showConfirmationModal}
        handleCloseModal={handleCloseConfirmationModal}
        handleConfirmDelete={handleConfirmDelete}
        confirmTitle="Lead Builder"
      />
      <FunctionsLimitModal
        show={showLimitModal}
        handleClose={handleCloseModal}
        getData={getFormBuilderListing}
      />
    </>
  );
};

export default FormBuilderListing;
